import { CdkMenu } from '@angular/cdk/menu';
import { Component, input } from '@angular/core';
import { IconName } from '@ng-icons/core';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmIconImports } from '@spartan-ng/helm/icon';

export type MenuItem<T, U = T> = {
  label: string;
  icon?: IconName;
  children?: MenuItem<U>[];
  action?: (data?: T) => void;
  type?: 'item' | 'checkbox';
  checked?: boolean;
};

@Component({
  selector: 'app-context-menu',
  imports: [HlmButtonImports, HlmDropdownMenuImports, CdkMenu, HlmIconImports],
  templateUrl: './context-menu.component.html',
  styleUrl: './context-menu.component.scss',
})
export class ContextMenuComponent<T> {
  readonly menuItems = input.required<MenuItem<T>[]>();
  readonly data = input<T | undefined>(undefined);
}
